<script setup lang="ts">
    import Toast from "primevue/toast";
    import ConfirmDialog from "primevue/confirmdialog";
    import { provide } from "vue";
    import { FieldConstraints } from "@/composables/api/field";
    import { DefaultValidators } from "./composables/validate";

    const props = defineProps<{
        roles: any[];
        licenceTypes: any[];
        fieldConstraints: FieldConstraints;
        defaultValidators: DefaultValidators;
    }>();

    provide("roles", props.roles);
    provide("licenceTypes", props.licenceTypes);
    provide("fieldConstraints", props.fieldConstraints);
    provide("defaultValidators", props.defaultValidators);
</script>

<template>
    <div class="text-color">
        <Toast position="bottom-left" />
        <ConfirmDialog />
        <router-view />
    </div>
</template>
